<template>
  <div id="footer" class="container-fluid">
    <div class="container" v-if="!icp">
      <div class="footer-box">
        <div class="logo">
          <!-- <img src="@/assets/images/ic_nav_logo@2x.png" alt="logo图" /> -->
          <img :src="data.web_logo" alt="logo图" />
        </div>
        <div class="address">
          <p class="p"><span>公司地址</span><i>：</i>{{data.company_address}}</p>
          <p class="p"><span>联系电话</span><i>：</i>{{data.company_phone}}</p>          
          <p class="p"><span>ICP备案号</span><i>：</i><a href="https://beian.miit.gov.cn/" target="_blank"> {{data.web_site_icp}}</a></p>
          <p class="p"><span>渝公网安备</span><i>：</i><a href="https://beian.mps.gov.cn/#/" target="_blank"> {{data.web_site_icp_city}}</a></p>
        </div>
        <div class="qr-code">
          <img :src="data.wx_code_img" alt="qrcode" />
        </div>
       <a href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91500108203083336H-SAIC_SHOW_10000091500108203083336H1692257039269&signData=MEUCIQDRuWipjrY1pAZxzTkPMJGQWlchI/7QtpIUUFdmSVWWRgIgDmEKhTJ6TNNJrG+fdS86uF/dcImwDWQ/n2imBuWJmaw="> <div class="qr-code">
        <img src="@/assets/images/zhizhao.png" />
        </div></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {
    data: {
      type: Object,
      default: ()=> {}
    },
    icp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="less">
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #eee;
  overflow: hidden;
}
.footer-box {
  margin: 0 auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 210px;
}
.logo {
  width: 146px;
  height: 40px;
}
.logo > img {
  width: 100%;
  height: 100%;
}
.address {
  color: #333;
  line-height: 21px;
  font-weight: 400;
  font-size: 15px;
}
.address .p {
  margin: 0;
}
.address i {
  font-style: normal;
}
.qr-code {
  width: 104px;
  height: 104px;
}
.qr-code > img {
  width: 100%;
  height: 100%;
}
.beian-box {
  height: 62px;
  width: 100%;
  background: #eee;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  >p {
    font-size: 15px;
    line-height: 21px;
    color: #333;
    margin: 0;
  }
}
@media screen and (max-width: 768px) {
  #footer {
    padding: 27px 0;
  }
  .footer-box {
    display: flex;
    flex-direction: column;
    height: 260px;
    .logo {
      height: 30px;
      width: 110px;
    }
    .address {
      p {
        display: flex;
        flex-direction: column;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        line-height: 20px;
        >span {
          font-size: 12px;
          color: #666666;
        }
      }
      i {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue